import { refreshCurrentDate } from "../cpcoc/currentDate";
import { days } from "../cpcoc/days";
// refresh and countdowns
export function nextDate(interval, d, time, period, fromDate) {
    const now = fromDate || refreshCurrentDate(), t = now.getDay(), day = typeof d === "string" ? days.indexOf(d.toLowerCase()) : d, f = t > day ? day + 7 : day, o = Math.abs(t - f), date = new Date(now.getFullYear(), now.getMonth(), now.getDate() + o);
    period = period || "";
    interval = interval || 7;
    const dayInt = Math.trunc(interval);
    const minInt = Math.round(24 * 60 * (interval % 1));
    if (!time) {
        time = `${now.getHours()}:${now.getMinutes()}`;
        period = ""; // reset
    }
    const SplitTime = time.split(":");
    if (period.toLowerCase() === "pm" && SplitTime[0] !== "12") {
        SplitTime[0] = Number(SplitTime[0]) + 12;
    }
    else if (period.toLowerCase() === "am" && SplitTime[0] === "12") {
        SplitTime[0] = "00";
    }
    date.setHours(Number(SplitTime[0]), Number(SplitTime[1]));
    while (date.valueOf() <= now.valueOf()) {
        // if date is in the past increase
        date.setDate(date.getDate() + dayInt);
        date.setHours(date.getHours(), date.getMinutes() + minInt);
    }
    return date;
}
